import Vue from 'vue';
import vuetify from '../src/plugins/vuetify';
import router from '../src/router';
import store from '../src/store';
import App from '../src/app.vue';
import * as services from '../src/services';
import DatetimePickerBase from 'vuetify-datetime-picker/src/components/DatetimePicker.vue';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';

Vue.prototype.$api = services.default;

Vue.component('v-datetime-picker', {
  extends: DatetimePickerBase,
  props: {
    dateFormat: {
      type: String,
      default: 'dd-MM-yyyy',
    },
  },
});

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
    data: {
      pageTitle: '',
    },
    computed: {
      onlyAccountsCanAccess() {
        return ['accounts', 'admin'].includes(this.$store.state.auth.profile.role);
      },
    },
    methods: {
      hasAccess(privilege) {
        if (this.$store.state.auth.profile.role === "admin") return true;

        return (this.$store.state.auth.profile.privileges || []).includes(privilege);
      },
    },
    beforeMount: function() {
      if (this !== this.$root) return;

      if (this.$el && this.$el.outerHTML) {
        this.__TurbolinksAdapterOriginalOuterHTML__ = this.$el.outerHTML;
        var _this = this;
        document.addEventListener("turbolinks:before-cache", function teardown() {
          _this.$destroy();
          document.removeEventListener("turbolinks:before-cache", teardown);
        });
      }
    },
    destroyed: function() {
      if (!this.__TurbolinksAdapterOriginalOuterHTML__) return;

      this.$el.outerHTML = this.__TurbolinksAdapterOriginalOuterHTML__;
      delete this.__TurbolinksAdapterOriginalOuterHTML__;
    },
  }).$mount();
  document.body.appendChild(app.$el);
});